export default "__VITE_ASSET__B6fHmwLl__"